import store from "../../app/store/store";
import translate from "@noar-basf/commons";

export default () => {
  // const { auth } = store.getState();
  const { auth } = store.getState();
  const isAdmin = auth && auth.user && auth.user.profile.nome === 'ADMIN';
  // const isPostNews = auth.user.profile.nome === 'POSTNEWS';
  const { lang } = store.getState().i18n;
  const menu = {
    header: {
      self: {},
      items: [
        {
          title: translate(lang).menu.header.items.profiles,
          root: true,
          alignment: "left",
          page: "perfis"
        }
      ]
    },
    aside: {
      self: {},
      items: []
    }
  };


  if (isAdmin) {

    // menu.aside.items.push({
    //   title: "Dashboard",
    //   root: true,
    //   icon: "flaticon2-architecture-and-city",
    //   page: "admin/dashboard",
    //   translate: "MENU.DASHBOARD",
    //   bullet: "dot"
    // });

    // if (isAdmin) {
    //   menu.aside.items.push({
    //     title: "Perfis",
    //     root: true,
    //     icon: "flaticon-map",
    //     page: "admin/perfis",
    //     translate: "MENU.PROFILES",
    //     bullet: "dot"
    //   });
    // }

    menu.aside.items.push({
      title: translate(lang).menu.user.title,
      root: true,
      icon: "flaticon2-group",
      bullet: "dot",
      page: "admin/users"
    });

    menu.aside.items.push({
      title: translate(lang).menu.fragrance.title,
      root: true,
      icon: "flaticon2-wifi",
      bullet: "dot",
      submenu: [
        {
          title: translate(lang).menu.fragrance.submenu.config,
          page: "admin/fragrances"
        },
        {
          title: translate(lang).menu.fragrance.submenu.categories,
          page: "admin/categories"
        }
      ]
    });

    // if (isAdmin) {
    //   menu.aside.items.push({
    //     title: "Enviar E-mails",
    //     root: true,
    //     icon: "flaticon2-mail-1",
    //     page: "admin/emails",
    //     bullet: "dot"
    //   });
    // }
    menu.aside.items.push({
      title: translate(lang).menu.campaign.title,
      root: true,
      icon: "flaticon2-writing",
      bullet: "dot",
      page: "admin/campaigns"
    });

    // menu.aside.items.push({
    //   title: translate(lang).menu.quiz?.title?.quiz,
    //   root: true,
    //   icon: "flaticon2-chat",
    //   bullet: "dot",
    //   page: "admin/quiz"
    // });

    menu.aside.items.push({
      title: translate(lang).screens.device?.title,
      root: true,
      icon: "flaticon2-pie-chart-2",
      bullet: "dot",
      page: "admin/devices"
    });

    menu.aside.items.push({
      title: translate(lang).screens.capsule?.title,
      root: true,
      icon: "flaticon2-safe",
      bullet: "dot",
      page: "admin/capsules"
    });

    menu.aside.items.push({
      title: translate(lang).screens.news?.title || 'News',
      root: true,
      icon: "flaticon2-writing",
      bullet: "dot",
      page: "admin/news"
    });
  }else {
    menu.aside.items.push({
      title: translate(lang).screens.news?.title || 'News',
      root: true,
      icon: "flaticon2-writing",
      bullet: "dot",
      page: "admin/news"
    });
  }


  return menu;
};
